/**
 * @description 环境变量: 接口基地址配置
 */

let buildEnv = process.env.VUE_APP_ENV || ''

const K_V_MAP = new Map<string, string>([
  // ['development', 'http://192.168.198.251:8081'],
  // ['development', 'https://backend-api.tutuapp.net'],
  ['development', 'https://test-backend-api.tutuapp.net'],
  // ['production', 'https://backend-admin-api.tutuapp.net']
  // ['development', 'http://192.168.8.136:8081'],
  ['test', 'https://test-backend-api.tutuapp.net'],
  ['production', 'https://backend-api.tutuapp.net']
])

export default K_V_MAP.get(buildEnv)
